var _g, _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJava(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 261,
    viewBox: "0 0 261 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_936_5091)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.5892,
    y: 36.8906,
    width: 180,
    height: 180,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.0892,
    y: 37.3906,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "#D9D9D9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.742 153.821C117.742 153.821 113.921 156.044 120.462 156.796C128.386 157.699 132.436 157.57 141.168 155.917C141.168 155.917 143.464 157.357 146.67 158.604C127.094 166.994 102.366 158.118 117.742 153.821ZM115.35 142.873C115.35 142.873 111.064 146.046 117.61 146.723C126.074 147.596 132.759 147.667 144.327 145.44C144.327 145.44 145.927 147.062 148.443 147.949C124.774 154.87 98.4113 148.495 115.35 142.873Z",
    fill: "#5382A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.516 124.301C140.34 129.854 134.249 134.851 134.249 134.851C134.249 134.851 146.496 128.529 140.871 120.611C135.618 113.228 131.589 109.559 153.399 96.9102C153.399 96.9102 119.165 105.46 135.516 124.3",
    fill: "#E76F00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M161.407 161.919C161.407 161.919 164.235 164.249 158.292 166.051C146.993 169.475 111.262 170.508 101.337 166.188C97.7686 164.636 104.46 162.482 106.564 162.03C108.759 161.554 110.014 161.642 110.014 161.642C106.046 158.847 84.366 167.131 99.0017 169.503C138.915 175.976 171.76 166.589 161.407 161.919ZM119.579 131.529C119.579 131.529 101.405 135.846 113.143 137.413C118.1 138.076 127.98 137.926 137.184 137.155C144.705 136.521 152.258 135.172 152.258 135.172C152.258 135.172 149.606 136.308 147.687 137.618C129.231 142.472 93.5767 140.214 103.841 135.249C112.522 131.053 119.58 131.529 119.58 131.529H119.579ZM152.183 149.753C170.945 140.003 162.27 130.635 156.215 131.897C154.731 132.206 154.069 132.473 154.069 132.473C154.069 132.473 154.62 131.61 155.672 131.237C167.651 127.025 176.863 143.657 151.806 150.244C151.806 150.244 152.096 149.985 152.183 149.753Z",
    fill: "#5382A1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M140.871 76.4856C140.871 76.4856 151.262 86.88 131.017 102.863C114.782 115.684 127.315 122.994 131.01 131.346C121.533 122.796 114.579 115.269 119.245 108.264C126.092 97.981 145.064 92.9955 140.871 76.4854",
    fill: "#E76F00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.423 176.171C139.432 177.324 167.086 175.531 167.741 167.01C167.741 167.01 166.482 170.24 152.858 172.806C137.487 175.698 118.529 175.36 107.285 173.507C107.286 173.507 109.587 175.412 121.423 176.171",
    fill: "#5382A1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_936_5091",
    x: 0.589233,
    y: 0.890625,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_936_5091"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_936_5091",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJava);
export default __webpack_public_path__ + "static/media/java.457d5175a3f240c0c10008e376ec5b6c.svg";
export { ForwardRef as ReactComponent };